module.exports = "/assets/data/307b5f951e8294f711c32bab3fe225a7-BT40.data.json";